// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const removeClaManagerMutation = gql`
  mutation removeClaManager($input: removeClaManagerInput!) {
    removeClaManager(input: $input) {
      code
      message
      success
    }
  }
`;
